import styled from 'styled-components';

export const InputLabel = styled.label`
  color: ${(props) => (props.color ? props.color : '#003232')};
  font-size: 14px;
  margin-bottom: 8px;

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    font-size: 14px;
  }
`;
